<section>
    <h2>Kods</h2>
    <h1>{addDash(insertedCode)}</h1>

    {#if !joining}
        <div class="keypad">
            <Key on:click={()=>keyPress(1)}>1</Key>
            <Key on:click={()=>keyPress(2)}>2</Key>
            <Key on:click={()=>keyPress(3)}>3</Key>
            <Key on:click={()=>keyPress(4)}>4</Key>
            <Key on:click={()=>keyPress(5)}>5</Key>
            <Key on:click={()=>keyPress(6)}>6</Key>
            <Key on:click={()=>keyPress(7)}>7</Key>
            <Key on:click={()=>keyPress(8)}>8</Key>
            <Key on:click={()=>keyPress(9)}>9</Key>
            <Key code={insertedCode} on:click={()=>keyPress("<")}>{`<`}</Key>
            <Key on:click={()=>keyPress(0)}>0</Key>            
        </div>
        <div class="info">Ja Tev nav kods - atver <span>KVIZ.party</span> uz datora!</div>
    {:else}
        <Loading />
    {/if}
</section>

<style>
h2 {
    font-size: 2em;
}
h1 {
    font-size: 2.5em;
    margin: 0.4em;
}
section {
    text-align: center;
}
.keypad{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 0.5em;
    margin: 0px 30px;
}
.info {
    margin-top: 3em;
    font-size: 0.8em;
}
.info > span {
    color: white;
}
</style>

<script>
import { onDestroy } from 'svelte'
import Key from "../../components/buttons/Key.svelte"
import BackButton from "../../components/buttons/Back.svelte"
import Loading from "../../layout/Loading.svelte"

import { join } from "../../stores/join"

export let socket

let insertedCode = ''
const addDash = code => code.substr(0,3) + '-' + code.substr(3,3)

let joining = false

const keyPress = no => {
    if (joining) return;

    if (no === '<') {
        insertedCode = insertedCode.substr(0, insertedCode.length - 1)
        return;
    }
    insertedCode += no

    if (insertedCode.length >= 6) {
        joining = true
        socket.emit('join', insertedCode)
    }
}

const unsub = join.subscribe( data => {
    if (!data.room) {
        insertedCode = ''
        joining = false
    }
} )
onDestroy(unsub)
</script>